<template>
	<div :class="'input-item ' + classList + ' ' + containerClasses" :style="styles">
		<label class="input-label" :for="id" v-if="label !== ''"
			>{{ label }} <span class="asterisk" v-if="asterisk">*</span>
			<icon type="help" class="not-mobile help-icon-for-field" v-if="help !== ''" :tooltip="help"></icon
		></label>
		<div class="input-field-block select-field-block">
			<select
				:autocomplete="autocomplete"
				:autofocus="autofocus"
				:class="'select ' + classList + ' ' + extraClasses"
				:disabled="disabled"
				:id="id"
				:name="name"
				:readonly="readonly"
				:required="required"
				:spellcheck="spellcheck"
				:style="inputStyles"
				@blur="blur"
				@change="update($event)"
				@focus="focus"
				@keypress.enter="keypressEnter($event)"
				v-model="selectedValue"
			>
				<option v-if="placeholder !== ''" :disabled="placeholderDisabled" :value="null">
					{{ placeholder }}
				</option>
				<slot name="option" v-for="option in options" :option="option"></slot>
			</select>
		</div>
		<p class="input-help error" v-if="error" v-html="error"></p>
		<p class="input-help only-mobile" v-if="help !== ''" v-html="help"></p>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		id: { default: "" },
		name: { default: "" },
		value: { default: null },
		options: {
			default: function () {
				return [];
			},
		},
		placeholder: { default: "" },

		label: { default: "" },
		help: { default: "" },

		error: { default: false },
		required: { default: false },
		disabled: { default: false },
		asterisk: { default: false },
		readonly: { default: false },
		autofocus: { default: false },
		spellcheck: { default: false },
		preventEnter: { default: false },
		autocomplete: { default: "on" }, // on/off

		hasError: { default: false },
		hasSuccess: { default: false },
		isLoading: { default: false },
		isFull: { default: false },
		placeholderDisabled: { default: true },

		extraClasses: { default: "" },
		containerClasses: { default: "" },
		width: { default: null },
		size: { default: "regular" }, // regular, large
	},

	data: function () {
		return {
			generatedInputStyles: [],
			hasFocus: false,
			selectedValue: "",
		};
	},

	methods: {
		update(e) {
			this.$emit("input", this.selectedValue);
			this.$emit("change", this.selectedValue);
		},

		keypressEnter(e) {
			if (this.preventEnter) {
				e.preventDefault();
			}

			this.$emit("keypress.enter", e);
			this.$emit("enter", e);
		},

		focus() {
			this.hasFocus = true;
			this.$emit("focus");
		},

		blur() {
			this.hasFocus = false;
			this.$emit("blur");
		},
	},

	watch: {
		options: function (newOptions) {
			this.selectedValue = this.value;
			this.$emit("input", this.selectedValue);
		},
		value: function (newValue) {
			this.selectedValue = this.value;
		},
	},

	computed: {
		styles() {
			let style = {};

			if (this.width !== null) {
				style["width"] = this.width;
			}

			return style;
		},

		inputStyles() {
			let style = {};

			this.generatedInputStyles.forEach(function (item) {
				style[item.type] = item.value;
			});

			return style;
		},

		classList() {
			let classList = "";

			classList += " size-" + this.size;

			if (this.label !== "") {
				classList += " has-label";
			}

			if (this.help !== "") {
				classList += " has-help";
			}

			if (this.hasSuccess) {
				classList += " has-success";
			}

			if (this.hasError || this.error) {
				classList += " has-error";
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.required) {
				classList += " is-required";
			}

			if (this.hasFocus) {
				classList += " has-focus";
			}

			return classList;
		},
	},

	mounted() {
		this.selectedValue = this.value;
	},
};
</script>
